import { render, staticRenderFns } from "./AddMenuModal.vue?vue&type=template&id=06ba49d9&"
import script from "./AddMenuModal.vue?vue&type=script&lang=js&"
export * from "./AddMenuModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports